  
    import React from 'react';

    const LoadingMedication = () => (
      <div className="text-left" style={{marginLeft:"15px"}}>
        <i className="fa fa-spinner fa-spin" /> Medication is being prepared. Please wait...
      </div>
    );

    export default LoadingMedication;
  
